export const DEFAULT_APP_LANGUAGE = "en-US"

export const supportedLanguages = [
	"bg-BG",
	"cs-CZ",
	"de-DE",
	"el-GR",
	"en-US",
	"es-ES",
	"fr-FR",
	"it-IT",
	"nl-NL",
	"no-NO",
	"pl-PL",
	"ro-RO",
	"sv-SE",
] as const
export type SupportedLanguages = (typeof supportedLanguages)[number]

export const parseEnabledTranslations = (
	raw: SupportedLanguages[] | string | undefined,
): readonly SupportedLanguages[] => {
	if (!raw) return supportedLanguages

	try {
		// Vite env vars are strings at runtime despite the declared type
		const parsed: SupportedLanguages[] =
			typeof raw === "string" ? JSON.parse(raw) : raw
		const filtered = supportedLanguages.filter(lang =>
			parsed.includes(lang),
		)
		return filtered.length > 0 ? filtered : supportedLanguages
	} catch {
		return supportedLanguages
	}
}

export const withDefaultLanguage = (
	langs: readonly SupportedLanguages[],
): readonly SupportedLanguages[] =>
	langs.includes(DEFAULT_APP_LANGUAGE)
		? langs
		: [DEFAULT_APP_LANGUAGE, ...langs]

export const enabledLanguages = withDefaultLanguage(
	parseEnabledTranslations(import.meta.env.VITE_ENABLED_TRANSLATIONS),
)

export const defaultNS = "shared"
